<template>
  <div>
    <JerarquiaMedalla :id="usuario.jerarquiaId"></JerarquiaMedalla>
    <span>{{usuario.nombre}}</span>
  </div>
</template>

<script>
import JerarquiaMedalla from "../empleado/JerarquiaMedalla";
export default {
  props: {
    usuario: {
      jerarquiaId: 0,
      nombre: "",
    },
  },
  components: {
    JerarquiaMedalla,
  },
};
</script>

<style>
</style>